import type { AppSelector, DashboardState } from "src/types";

const getModel: AppSelector<DashboardState> = (state) => state.dashboard;

export const getWeekOffset: AppSelector<number> = (state) => getModel(state).weekOffset;
